import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          <p>&copy; 2024 <strong>Lance and Yuri Kids Spot Naga City</strong>. All rights reserved. Made with 💖 for amazing kids! 🌈</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 